import { useEffect } from "react";
import Aos from "aos";
import "aos/dist/aos.css";

import HeroMockup from "../assets/cover0fixerfind.png";
import Banner from "../assets/wallpaper.jpeg";
import Browse from "../assets/mockA.png";
import Profile from "../assets/mockF.png";
import Booking from "../assets/mockC.png";
import Close from "../assets/mock8.png";

export default function Portfolio() {
    useEffect(() => {
        Aos.init({ duration: 1200, once: true });
    }, []);

    return (
        <div className="bg-white text-gray-900 overflow-x-hidden">

            {/* Hero */}
            <section className="max-w-6xl mx-auto px-6 md:px-12 lg:px-24 py-28 text-center">
                <div data-aos="fade-up" className="max-w-6xl mx-auto text-center">
                    <h1 className="text-4xl md:text-5xl font-extrabold text-blue-600 mb-6">
                        FixerFind Portfolio
                    </h1>
                    <p className="text-lg text-gray-600 max-w-3xl mx-auto">
                        A people-first platform for essential services that makes it easy to find, verify, and hire dependable local professionals.
                    </p>

                    <div className="mt-16">
                        <img
                            src={HeroMockup}
                            alt="FixerFind platform overview"
                            className=" rounded-3xl shadow-2xl mx-auto w-full max-w-md md:max-w-lg lg:max-w-2xl object-contain" />
                    </div>
                </div>
            </section>

            {/* What We Built */}
            <section className="bg-gray-50 py-20 px-6 md:px-12 lg:px-24">
                <div data-aos="fade-up" className="max-w-6xl mx-auto text-center">
                    <h2 className="text-3xl font-bold text-blue-600 mb-6">
                        What We Built
                    </h2>
                    <p className="text-gray-700 max-w-3xl mx-auto">
                        FixerFind is an end-to-end services platform that connects customers with vetted providers of essential services through location-based discovery, trusted verification, and streamlined booking.
                    </p>
                </div>
            </section>

            <section className="relative py-32 bg-gradient-to-br from-blue-600 to-blue-500 overflow-hidden">
                <div className="absolute inset-0 opacity-10">
                    <img
                        src={Banner}
                        alt=""
                        className="w-full h-full object-cover"
                    />
                </div>

                <div data-aos="zoom-in" className="relative max-w-5xl mx-auto px-6 text-center">
                    <h2 className="text-4xl md:text-5xl font-extrabold text-white mb-6">
                        Built for Speed, Trust & Scale
                    </h2>
                    <p className="text-blue-100 text-lg max-w-3xl mx-auto">
                        Every interaction on FixerFind is designed to reduce friction,
                        build confidence, and deliver real-world results.
                    </p>
                </div>
            </section>

            {/* Stats Section */}
            <section className="bg-gray-50 py-24">
                <div className="max-w-6xl mx-auto px-6 grid grid-cols-2 md:grid-cols-4 gap-12 text-center">
                    {[
                        { label: "Bookings", value: "10K+" },
                        { label: "City", value: "Lagos" },
                        { label: "Providers", value: "2.5K+" },
                        { label: "Happy Users", value: "20K+" },
                    ].map((stat, i) => (
                        <div data-aos="fade-up" key={i} className="space-y-2">
                            <div className="text-4xl font-extrabold  text-blue-500">{stat.value}</div>
                            <div className="text-gray-600">{stat.label}</div>
                        </div>
                    ))}
                </div>
            </section>

            {/* Core Flows */}
            <section className="max-w-6xl mx-auto px-6 md:px-12 lg:px-24 py-24 space-y-24">

                {/* Browse */}
                <div data-aos="fade-up" className="md:flex md:items-center md:gap-16">
                    <div className="md:w-1/2">
                        <h3 className="text-2xl font-semibold text-blue-500 mb-4">
                            Service Discovery
                        </h3>
                        <p className="text-gray-700">
                            Users can browse nearby service providers by category,
                            location, availability, and rating — reducing search friction
                            and uncertainty.
                        </p>
                    </div>
                    <div className="md:w-1/2 mt-8 md:mt-0">
                        <img
                            src={Browse}
                            alt="Service browsing"
                            className="app-mockup rounded-2xl shadow-xl w-full max-w-sm md:max-w-md lg:max-w-lg mx-auto object-contain" />
                    </div>
                </div>

                {/* Profile */}
                <div data-aos="fade-up" className="md:flex md:flex-row-reverse md:items-center md:gap-16">
                    <div className="md:w-1/2">
                        <h3 className="text-2xl font-semibold text-blue-500 mb-4">
                            Provider Profiles & Trust
                        </h3>
                        <p className="text-gray-700">
                            Each provider’s profile clearly shows they are verified, with reviews and service history that help users hire with confidence.
                        </p>
                    </div>
                    <div className="md:w-1/2 mt-8 md:mt-0">
                        <img
                            src={Profile}
                            alt="Provider profile"
                            className=" rounded-2xl shadow-xl w-full max-w-sm md:max-w-md lg:max-w-lg mx-auto object-contain" />
                    </div>
                </div>

                {/* Booking */}
                <div data-aos="fade-up" className="md:flex md:items-center md:gap-16">
                    <div className="md:w-1/2">
                        <h3 className="text-2xl font-semibold text-blue-500 mb-4">
                            Simple Booking Flow
                        </h3>
                        <p className="text-gray-700">
                            FixerFind simplifies engagement with clear actions,
                            transparent communication, and fast confirmations —
                            reducing delays and failed service attempts.
                        </p>
                    </div>
                    <div className="md:w-1/2 mt-8 md:mt-0">
                        <img
                            src={Booking}
                            alt="Booking flow"
                            className=" rounded-2xl shadow-xl w-full max-w-sm md:max-w-md lg:max-w-lg mx-auto object-contain" />
                    </div>
                </div>
            </section>

            <section className="bg-white py-24 px-6 md:px-12 lg:px-24">
                <div data-aos="fade-up" className="max-w-5xl mx-auto text-center space-y-6">
                    <h2 className="text-3xl font-bold text-blue-600">
                        The Problem We Solved
                    </h2>
                    <p className="text-gray-700 max-w-3xl mx-auto">
                        Finding reliable service providers in emerging markets is often slow,
                        unsafe, and unreliable. Users face unverified workers, unclear pricing,
                        and broken communication.
                    </p>
                    <p className="text-gray-700 max-w-3xl mx-auto">
                        FixerFind solves this by combining verified providers, location-based
                        discovery, and structured booking — all in one trusted platform.
                    </p>
                </div>
            </section>


            <section className="bg-gray-50 py-24 px-6 md:px-12 lg:px-24">
                <div data-aos="fade-up" className="max-w-6xl mx-auto">
                    <h2 className="text-3xl font-bold text-blue-600 text-center mb-12">
                        Platform Capabilities
                    </h2>

                    <div className="grid md:grid-cols-3 gap-10">
                        {[
                            {
                                title: "Verified Providers",
                                desc: "Identity checks, profile reviews, and service history build trust."
                            },
                            {
                                title: "Location-Based Matching",
                                desc: "Smart discovery connects users to nearby providers instantly."
                            },
                            {
                                title: "Flexible Pricing Models",
                                desc: "Standard and Premium plans support multiple monetization strategies."
                            },
                            {
                                title: "Secure Communication",
                                desc: "In-app messaging protects user privacy and reduces fraud."
                            },
                            {
                                title: "Scalable Architecture",
                                desc: "Designed to support rapid growth across cities and service categories."
                            },
                            {
                                title: "Data-Driven Insights",
                                desc: "Admin dashboards track bookings, performance, and engagement."
                            },
                        ].map((item, i) => (
                            <div key={i} className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition">
                                <h3 className="text-xl font-semibold text-blue-500 mb-3">
                                    {item.title}
                                </h3>
                                <p className="text-gray-600">
                                    {item.desc}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <section className="bg-white py-24 px-6 md:px-12 lg:px-24">
                <div className="max-w-6xl mx-auto space-y-16">

                    <div data-aos="fade-up" className="text-center">
                        <h2 className="text-3xl font-bold text-blue-600 mb-4">
                            Designed for Real Users
                        </h2>
                        <p className="text-gray-600 max-w-3xl mx-auto">
                            A clean interface that feels intuitive for both customers and service providers.
                        </p>
                    </div>

                    <div className="grid md:grid-cols-2 gap-12">
                        <div data-aos="fade-right">
                            <img
                                src={Close}
                                alt="User browsing services"
                                className=" rounded-3xl shadow-2xl w-full max-w-md lg:max-w-lg mx-auto max-h-[800px] object-contain" />
                        </div>

                        <div data-aos="fade-left" className="flex flex-col justify-center space-y-6">
                            <h3 className="text-2xl font-semibold text-blue-500">
                                Intuitive Discovery Experience
                            </h3>
                            <p className="text-gray-700">
                                Optimized layouts, clear calls-to-action, and fast search results
                                guide users from discovery to booking effortlessly.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

        </div>
    );
}
